import { render, staticRenderFns } from "./InstitutionSettingsSessions.vue?vue&type=template&id=5429be8d"
import script from "./InstitutionSettingsSessions.vue?vue&type=script&lang=js"
export * from "./InstitutionSettingsSessions.vue?vue&type=script&lang=js"
import style0 from "./InstitutionSettingsSessions.vue?vue&type=style&index=0&id=5429be8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports